export default [
  {
    label: 'Student ID',
    key: 'studentId',
    sortable: true,
    visible: true,
  },
  {
    label: 'First Name',
    key: 'firstName',
    sortable: true,
    visible: true,
  },
  {
    label: 'Last Name',
    key: 'lastName',
    sortable: true,
    visible: true,
  },
  {
    label: 'Date of Birth',
    key: 'dateOfBirth',
    sortable: true,
    visible: true,
  },
  {
    label: 'School',
    key: 'building.name',
    sortable: true,
    visible: true,
  },
  {
    key: 'Actions',
    visible: true,
  },
]
